// Author Lin
// Date 2024-07-30 14:37:40

class SithMesInventoryItem {
    constructor({
                    id = null,
                    purchaseNumber = '',
                    itemCode = '',
                    projectWbs = '',
                    purchaseGroup = '',
                    creatorName = '',
                    creatorGid = '',
                    vendorNumber = '',
                    vendorEngName = '',
                    vendorChnName = '',
                    poCrtDate = '',
                    requiredArrivalDate = '',
                    actualArrivalDate = '',
                    plant = '',
                    confirmCategory = '',
                    vendorConfirmDate = '',
                    materielWbs = '',
                    materielCode = '',
                    materielName = '',
                    purchaseQuantity = '',
                    arrivedQuantity = '',
                    materielUnit = '',
                    texture = '',
                    weight = '',
                    weightUnit = '',
                    descriptionCh = '',
                    descriptionEn = '',
                    figureNumber = '',
                    productionNumber = '',
                    urgency = '',
                    taxFlag = '',
                    size = '',
                    locId = '',
                    locName = '',
                    packingBom = '',
                    shelfLife = '',
                    productionDate = '',
                    batchNumber = '',
                    requireTakeTime = '',
                    actualTakeTime = '',
                    requireReturnTime = '',
                    actualReturnTime = '',
                    firstLevelReason = '',
                    secondLevelReason = '',
                    ncrCode = '',
                    receivingExceptionType = '',
                    receivingExceptionInfo = '',
                    receivingExceptionFeedback = '',
                    receivingType = '',
                    receivingQuantity = '',
                    receivingDate = '',
                    consigneeId = '',
                    assignedConsigneeId = '',
                    assignedConsignee = '',
                    inventoryStatusCode = '',
                    incomingTime = '',
                    qualityInspectionReceiver = '',
                    receivingDate105 = '',
                    storagePerson = '',
                    storageDate = '',
                    category = '',
                    poItemCategory = '',
                    receivingDate103 = '',
                    inspectionFinishDate105 = '',
                    purchaserId = '',
                    inspectionResult105 = '',
                    attachment = '',
                    remark = '',
                    costCenter = '',
                    carNumber = '',
                    expressNumber = '',
                    soNumber = '',
                    soItem = '',
                    arrivalConfirmId = '',
                    packingMaterial = '',
                    deletion = '',
                    attachmentList = ''
                }
                        = {}) {
        this.id = id;
        this.purchaseNumber = purchaseNumber;
        this.itemCode = itemCode;
        this.projectWbs = projectWbs;
        this.purchaseGroup = purchaseGroup;
        this.creatorName = creatorName;
        this.creatorGid = creatorGid;
        this.vendorNumber = vendorNumber;
        this.vendorEngName = vendorEngName;
        this.vendorChnName = vendorChnName;
        this.poCrtDate = poCrtDate;
        this.requiredArrivalDate = requiredArrivalDate;
        this.actualArrivalDate = actualArrivalDate;
        this.plant = plant;
        this.confirmCategory = confirmCategory;
        this.vendorConfirmDate = vendorConfirmDate;
        this.materielWbs = materielWbs;
        this.materielCode = materielCode;
        this.materielName = materielName;
        this.purchaseQuantity = purchaseQuantity;
        this.arrivedQuantity = arrivedQuantity;
        this.materielUnit = materielUnit;
        this.texture = texture;
        this.weight = weight;
        this.weightUnit = weightUnit;
        this.descriptionCh = descriptionCh;
        this.descriptionEn = descriptionEn;
        this.figureNumber = figureNumber;
        this.productionNumber = productionNumber;
        this.urgency = urgency;
        this.taxFlag = taxFlag;
        this.size = size;
        this.locId = locId;
        this.locName = locName;
        this.packingBom = packingBom;
        this.shelfLife = shelfLife;
        this.productionDate = productionDate;
        this.batchNumber = batchNumber;
        this.requireTakeTime = requireTakeTime;
        this.actualTakeTime = actualTakeTime;
        this.requireReturnTime = requireReturnTime;
        this.actualReturnTime = actualReturnTime;
        this.firstLevelReason = firstLevelReason;
        this.secondLevelReason = secondLevelReason;
        this.ncrCode = ncrCode;
        this.receivingExceptionType = receivingExceptionType;
        this.receivingExceptionInfo = receivingExceptionInfo;
        this.receivingExceptionFeedback = receivingExceptionFeedback;
        this.receivingType = receivingType;
        this.receivingQuantity = receivingQuantity;
        this.receivingDate = receivingDate;
        this.consigneeId = consigneeId;
        this.assignedConsigneeId = assignedConsigneeId;
        this.assignedConsignee = assignedConsignee;
        this.inventoryStatusCode = inventoryStatusCode;
        this.incomingTime = incomingTime;
        this.qualityInspectionReceiver = qualityInspectionReceiver;
        this.receivingDate105 = receivingDate105;
        this.storagePerson = storagePerson;
        this.storageDate = storageDate;
        this.category = category;
        this.poItemCategory = poItemCategory;
        this.receivingDate103 = receivingDate103;
        this.inspectionFinishDate105 = inspectionFinishDate105;
        this.purchaserId = purchaserId;
        this.inspectionResult105 = inspectionResult105;
        this.attachment = attachment;
        this.remark = remark;
        this.costCenter = costCenter;
        this.carNumber = carNumber;
        this.expressNumber = expressNumber;
        this.soNumber = soNumber;
        this.soItem = soItem;
        this.arrivalConfirmId = arrivalConfirmId;
        this.packingMaterial = packingMaterial;
        this.deletion = deletion;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new SithMesInventoryItem();
}

const receive103VoConfigs = [
    {
        key: 'purchaseNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCode',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.itemCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.projectWbs',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroup',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseGroup',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.creatorName',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorGid',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.creatorGid',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorNumber',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorEngName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorEngName',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorChnName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorChnName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poCrtDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.poCrtDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.requiredArrivalDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.actualArrivalDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.plant',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.confirmCategory',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorConfirmDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorConfirmDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielWbs',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielCode',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivedQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.arrivedQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielUnit',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'texture',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.texture',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.weight',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightUnit',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.weightUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionCh',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.descriptionCh',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionEn',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.descriptionEn',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'figureNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.figureNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.productionNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'urgency',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.urgency',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '紧急'},
                {value: '1', text: '一般'}
            ]
        }
    },
    {
        key: 'taxFlag',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.taxFlag',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '免税'},
                {value: '1', text: '不免税'}
            ]
        }
    },
    {
        key: 'size',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.size',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '大件物料'},
                {value: '1', text: '中等物料'},
                {value: '2', text: '小件物料'}
            ]
        }
    },
    {
        key: 'locName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.locName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingBom',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.packingBom',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shelfLife',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.shelfLife',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.productionDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.batchNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consigneeId',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.consigneeId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consignee',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.consignee',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'assignedConsigneeId',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.assignedConsigneeId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'assignedConsignee',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.assignedConsignee',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.statusName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTime',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.incomingTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'category',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.category',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.poItemCategory',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate103',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingDate103',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaserName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'credential',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.credential',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.attachmentList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivalConfirmName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.arrivalConfirmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterial',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.packingMaterial',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.deletion',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]
const receive105VoConfigs = [
    {
        key: 'purchaseNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCode',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.itemCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.projectWbs',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroup',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseGroup',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.creatorName',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorGid',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.creatorGid',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorNumber',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorEngName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorEngName',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorChnName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorChnName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poCrtDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.poCrtDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.requiredArrivalDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.actualArrivalDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.plant',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.confirmCategory',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorConfirmDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorConfirmDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielWbs',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielCode',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivedQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.arrivedQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielUnit',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'texture',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.texture',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.weight',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightUnit',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.weightUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionCh',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.descriptionCh',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionEn',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.descriptionEn',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'figureNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.figureNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.productionNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'urgency',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.urgency',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '紧急'},
                {value: '1', text: '一般'}
            ]
        }
    },
    {
        key: 'taxFlag',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.taxFlag',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '免税'},
                {value: '1', text: '不免税'}
            ]
        }
    },
    {
        key: 'size',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.size',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '大件物料'},
                {value: '1', text: '中等物料'},
                {value: '2', text: '小件物料'}
            ]
        }
    },
    {
        key: 'locName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.locName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingBom',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.packingBom',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.batchNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.statusName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTime',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.incomingTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualityInspectionReceiver',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.qualityInspectionReceiver',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate105',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingDate105',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'category',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.category',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.poItemCategory',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionFinishDate105',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.inspectionFinishDate105',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaserName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionResult105',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.inspectionResult105',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'credential',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.credential',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.attachmentList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivalConfirmName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.arrivalConfirmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterial',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.packingMaterial',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.deletion',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseNumber',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemCode',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.itemCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectWbs',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.projectWbs',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseGroup',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseGroup',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'creatorName',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.creatorName',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'creatorGid',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.creatorGid',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNumber',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorEngName',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorEngName',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorChnName',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorChnName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poCrtDate',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.poCrtDate',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'requiredArrivalDate',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.requiredArrivalDate',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualArrivalDate',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.actualArrivalDate',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'plant',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.plant',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'confirmCategory',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.confirmCategory',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorConfirmDate',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorConfirmDate',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materielWbs',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.materielWbs',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materielCode',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.materielCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materielName',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.materielName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseQuantity',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'arrivedQuantity',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.arrivedQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materielUnit',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.materielUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'texture',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.texture',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'weight',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.weight',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'weightUnit',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.weightUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'descriptionCh',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.descriptionCh',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'descriptionEn',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.descriptionEn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'figureNumber',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.figureNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'productionNumber',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.productionNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'urgency',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.urgency',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '紧急'},
                    {value: '1', text: '一般'}
                ]
            }
        },
        {
            key: 'taxFlag',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.taxFlag',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '免税'},
                    {value: '1', text: '不免税'}
                ]
            }
        },
        {
            key: 'size',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.size',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '大件物料'},
                    {value: '1', text: '中等物料'},
                    {value: '2', text: '小件物料'}
                ]
            }
        },
        {
            key: 'locName',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.locName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packingBom',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.packingBom',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'shelfLife',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.shelfLife',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'productionDate',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.productionDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'batchNumber',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.batchNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receivingQuantity',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receivingDate',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'consigneeId',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.consigneeId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'consignee',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.consignee',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'assignedConsigneeId',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.assignedConsigneeId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'assignedConsignee',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.assignedConsignee',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'statusName',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.statusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'incomingTime',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.incomingTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'qualityInspectionReceiver',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.qualityInspectionReceiver',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receivingDate105',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingDate105',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storagePerson',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.storagePerson',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageDate',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.storageDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'category',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.category',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItemCategory',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.poItemCategory',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receivingDate103',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingDate103',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectionFinishDate105',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.inspectionFinishDate105',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaserId',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaserId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaserName',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaserName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectionResult105',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.inspectionResult105',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'credential',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.credential',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'year',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.year',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.attachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'costCenter',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.costCenter',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'carNumber',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.carNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'expressNumber',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.expressNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'soNumber',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.soNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'soItem',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.soItem',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'arrivalConfirmId',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.arrivalConfirmId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'arrivalConfirmName',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.arrivalConfirmName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packingMaterial',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.packingMaterial',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deletion',
            label: 'label.sith.inventory.sithMesInventoryItem.grid.deletion',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const receive101VoConfigs = [
    {
        key: 'purchaseNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCode',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.itemCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.projectWbs',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroup',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseGroup',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.creatorName',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorGid',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.creatorGid',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorNumber',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorEngName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorEngName',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorChnName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorChnName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poCrtDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.poCrtDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.requiredArrivalDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.actualArrivalDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.plant',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.confirmCategory',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorConfirmDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.vendorConfirmDate',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielWbs',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielCode',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaseQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivedQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.arrivedQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielUnit',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.materielUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'texture',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.texture',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.weight',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightUnit',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.weightUnit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionCh',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.descriptionCh',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionEn',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.descriptionEn',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'figureNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.figureNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.productionNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'urgency',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.urgency',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '紧急'},
                {value: '1', text: '一般'}
            ]
        }
    },
    {
        key: 'taxFlag',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.taxFlag',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '免税'},
                {value: '1', text: '不免税'}
            ]
        }
    },
    {
        key: 'size',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.size',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '大件物料'},
                {value: '1', text: '中等物料'},
                {value: '2', text: '小件物料'}
            ]
        }
    },
    {
        key: 'locName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.locName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingBom',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.packingBom',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.batchNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.receivingDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consigneeId',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.consigneeId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consignee',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.consignee',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'assignedConsigneeId',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.assignedConsigneeId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'assignedConsignee',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.assignedConsignee',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.statusName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTime',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.incomingTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.purchaserName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'credential',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.credential',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.attachmentList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivalConfirmName',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.arrivalConfirmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterial',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.packingMaterial',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.inventory.sithMesInventoryItem.grid.deletion',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

const filter = {
    idFilter: '',
    idListFilter: [],
    categoryListFilter: [],
    purchaseNumberFilter: '',
    itemCodeFilter: '',
    projectWbsFilter: '',
    purchaseGroupFilter: '',
    creatorNameFilter: '',
    creatorGidFilter: '',
    vendorNumberFilter: '',
    vendorEngNameFilter: '',
    vendorChnNameFilter: '',
    poCrtDateFilter: '',
    requiredArrivalDateFilter: '',
    actualArrivalDateFilter: '',
    plantFilter: '',
    confirmCategoryFilter: '',
    vendorConfirmDateFilter: '',
    materielWbsFilter: '',
    materielCodeFilter: '',
    materielNameFilter: '',
    purchaseQuantityFilter: '',
    arrivedQuantityFilter: '',
    materielUnitFilter: '',
    textureFilter: '',
    weightFilter: '',
    weightUnitFilter: '',
    descriptionChFilter: '',
    descriptionEnFilter: '',
    figureNumberFilter: '',
    productionNumberFilter: '',
    urgencyFilter: '',
    taxFlagFilter: '',
    sizeFilter: '',
    locIdFilter: '',
    locNameFilter: '',
    packingBomFilter: '',
    shelfLifeFilter: '',
    productionDateRteFilter: '',
    productionDateLteFilter: '',
    batchNumberFilter: '',
    requireTakeTimeRteFilter: '',
    requireTakeTimeLteFilter: '',
    actualTakeTimeRteFilter: '',
    actualTakeTimeLteFilter: '',
    requireReturnTimeRteFilter: '',
    requireReturnTimeLteFilter: '',
    actualReturnTimeRteFilter: '',
    actualReturnTimeLteFilter: '',
    firstLevelReasonFilter: '',
    secondLevelReasonFilter: '',
    ncrCodeFilter: '',
    receivingExceptionTypeFilter: '',
    receivingExceptionInfoFilter: '',
    receivingExceptionFeedbackFilter: '',
    receivingTypeFilter: '',
    receivingQuantityFilter: '',
    receivingDateRteFilter: '',
    receivingDateLteFilter: '',
    consigneeIdFilter: '',
    consigneeFilter: '',
    assignedConsigneeIdFilter: '',
    assignedConsigneeFilter: '',
    statusInFilter: [],
    inventoryStatusCodeFilter: '',
    incomingTimeRteFilter: '',
    incomingTimeLteFilter: '',
    qualityInspectionReceiverFilter: '',
    receivingDate105RteFilter: '',
    receivingDate105LteFilter: '',
    storagePersonFilter: '',
    storageDateRteFilter: '',
    storageDateLteFilter: '',
    categoryFilter: '',
    poItemCategoryFilter: '',
    receivingDate103RteFilter: '',
    receivingDate103LteFilter: '',
    inspectionFinishDate105RteFilter: '',
    inspectionFinishDate105LteFilter: '',
    purchaserIdFilter: '',
    inspectionResult105Filter: '',
    costCenterFilter: '',
    carNumberFilter: '',
    expressNumberFilter: '',
    soNumberFilter: '',
    soItemFilter: '',
    arrivalConfirmIdFilter: '',
    arrivalConfirmNameFilter: '',
    packingMaterialFilter: '',
    deletionFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'purchaseNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaseNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.itemCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.projectWbs',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroupFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaseGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.vendorNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.materielWbs',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.materielCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.materielName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseQuantityFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaseQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielUnitFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.materielUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightUnitFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.weightUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionChFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.descriptionCh',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.productionNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'urgencyFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.urgency',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '紧急'},
                {value: '1', text: '一般'}
            ]
        }
    },
    {
        key: 'taxFlagFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.taxFlag',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '免税'},
                {value: '1', text: '不免税'}
            ]
        }
    },
    {
        key: 'sizeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.size',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '大件物料'},
                {value: '1', text: '中等物料'},
                {value: '2', text: '小件物料'}
            ]
        }
    },
    {
        key: 'locNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.locName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryAreaLoc'
            , correspondingField: 'areaName'
            , fieldsBindingByEntityModalSelected: '{"locId":"id"}'
        }
    },
    {
        key: 'shelfLifeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.shelfLife',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.batchNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDateRteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDateLteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consigneeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.consignee',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'assignedConsigneeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.assignedConsignee',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"assignedConsigneeId":"id"}'
        }
    },
    {
        key: 'inventoryStatusCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inventoryStatusCode',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'incomingTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.incomingTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.incomingTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualityInspectionReceiverFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.qualityInspectionReceiver',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate105RteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDate105Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate105LteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDate105Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'categoryFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.category',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate103RteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDate103Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate103LteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDate103Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionFinishDate105RteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inspectionFinishDate105Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionFinishDate105LteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inspectionFinishDate105Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserIdFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaserId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inspectionResult105Filter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inspectionResult105',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'carNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.carNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'expressNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.expressNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivalConfirmNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.arrivalConfirmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterialFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.packingMaterial',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletionFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.deletion',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];
const receive103FilterConfigs = [
    {
        key: 'purchaseNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaseNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.itemCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.projectWbs',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroupFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaseGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.vendorNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.materielCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.materielName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'urgencyFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.urgency',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '紧急'},
                {value: '1', text: '一般'}
            ]
        }
    },
    {
        key: 'locNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.locName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryAreaLoc'
            , correspondingField: 'areaName'
            , fieldsBindingByEntityModalSelected: '{"locId":"id"}'
        }
    },
    {
        key: 'consigneeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.consignee',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'assignedConsigneeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.assignedConsignee',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"assignedConsigneeId":"id"}'
        }
    },
    {
        key: 'inventoryStatusCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inventoryStatusCode',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'incomingTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.incomingTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.incomingTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'categoryFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.category',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate103RteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDate103Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate103LteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDate103Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserIdFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaserId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'arrivalConfirmNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.arrivalConfirmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterialFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.packingMaterial',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletionFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.deletion',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];
const receive105FilterConfigs = [
    {
        key: 'purchaseNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaseNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.itemCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.projectWbs',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroupFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaseGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.vendorNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.materielName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'urgencyFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.urgency',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '紧急'},
                {value: '1', text: '一般'}
            ]
        }
    },
    {
        key: 'locNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.locName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryAreaLoc'
            , correspondingField: 'areaName'
            , fieldsBindingByEntityModalSelected: '{"locId":"id"}'
        }
    },
    {
        key: 'batchNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.batchNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inventoryStatusCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inventoryStatusCode',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'qualityInspectionReceiverFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.qualityInspectionReceiver',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate105RteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDate105Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate105LteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDate105Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'categoryFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.category',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionFinishDate105RteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inspectionFinishDate105Rte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionFinishDate105LteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inspectionFinishDate105Lte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserIdFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaserId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inspectionResult105Filter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inspectionResult105',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivalConfirmNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.arrivalConfirmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterialFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.packingMaterial',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletionFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.deletion',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];
const receive101FilterConfigs = [
    {
        key: 'purchaseNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaseNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.itemCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.projectWbs',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroupFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaseGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.vendorNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.materielCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.materielName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.productionNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'urgencyFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.urgency',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '紧急'},
                {value: '1', text: '一般'}
            ]
        }
    },
    {
        key: 'locNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.locName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryAreaLoc'
            , correspondingField: 'areaName'
            , fieldsBindingByEntityModalSelected: '{"locId":"id"}'
        }
    },
    {
        key: 'receivingDateRteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDateLteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.receivingDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consigneeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.consignee',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'assignedConsigneeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.assignedConsignee',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"assignedConsigneeId":"id"}'
        }
    },
    {
        key: 'inventoryStatusCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.inventoryStatusCode',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'incomingTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.incomingTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'incomingTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.incomingTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserIdFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.purchaserId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'arrivalConfirmNameFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.arrivalConfirmName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterialFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.packingMaterial',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletionFilter',
        label: 'label.sith.inventory.sithMesInventoryItem.filter.deletion',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const receive103EntityConfigs = [
    {
        key: 'purchaseNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaseNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCode',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.itemCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.projectWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroup',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaseGroup',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.creatorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorGid',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.creatorGid',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorEngName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorEngName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorChnName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorChnName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poCrtDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.poCrtDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.requiredArrivalDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.actualArrivalDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.plant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.confirmCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorConfirmDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorConfirmDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shelfLife',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.shelfLife',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.productionDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.deletion',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]
const receive105EntityConfigs = [
    {
        key: 'purchaseNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaseNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCode',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.itemCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.projectWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroup',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaseGroup',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.creatorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorGid',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.creatorGid',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorEngName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorEngName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorChnName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorChnName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poCrtDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.poCrtDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.requiredArrivalDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.actualArrivalDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.plant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.confirmCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorConfirmDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorConfirmDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.batchNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionResult105',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.inspectionResult105',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.deletion',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]
const entityFormConfigs = [
    {
        key: 'purchaseNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaseNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCode',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.itemCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.projectWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroup',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaseGroup',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.creatorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorGid',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.creatorGid',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorEngName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorEngName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorChnName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorChnName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poCrtDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.poCrtDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.requiredArrivalDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.actualArrivalDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.plant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.confirmCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorConfirmDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorConfirmDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.materielWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielCode',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.materielCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.materielName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaseQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivedQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.arrivedQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materielUnit',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.materielUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'texture',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.texture',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.weight',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightUnit',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.weightUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionCh',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.descriptionCh',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'descriptionEn',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.descriptionEn',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'figureNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.figureNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.productionNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'urgency',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.urgency',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '紧急'},
                {value: '1', text: '一般'}
            ]
        }
    },
    {
        key: 'taxFlag',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.taxFlag',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '免税'},
                {value: '1', text: '不免税'}
            ]
        }
    },
    {
        key: 'size',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.size',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '大件物料'},
                {value: '1', text: '中等物料'},
                {value: '2', text: '小件物料'}
            ]
        }
    },
    {
        key: 'locName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.locName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryAreaLoc'
            , correspondingField: 'areaName'
            , fieldsBindingByEntityModalSelected: '{"locId":"id"}'
        }
    },
    {
        key: 'packingBom',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.packingBom',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'shelfLife',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.shelfLife',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.productionDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.batchNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requireTakeTime',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.requireTakeTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualTakeTime',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.actualTakeTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requireReturnTime',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.requireReturnTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualReturnTime',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.actualReturnTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'firstLevelReason',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.firstLevelReason',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'secondLevelReason',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.secondLevelReason',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrCode',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.ncrCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingExceptionType',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingExceptionType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingExceptionInfo',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingExceptionInfo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingExceptionFeedback',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingExceptionFeedback',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingType',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consigneeId',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.consigneeId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'assignedConsignee',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.assignedConsignee',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"assignedConsigneeId":"id"}'
        }
    },
    {
        key: 'inventoryStatusCode',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.inventoryStatusCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'incomingTime',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.incomingTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualityInspectionReceiver',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.qualityInspectionReceiver',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate105',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingDate105',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storagePerson',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.storagePerson',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.storageDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'category',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.category',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.poItemCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingDate103',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingDate103',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionFinishDate105',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.inspectionFinishDate105',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaserId',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaserId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inspectionResult105',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.inspectionResult105',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'costCenter',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.costCenter',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'carNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.carNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'expressNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.expressNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'soNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.soNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'soItem',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.soItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'arrivalConfirmId',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.arrivalConfirmId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterial',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.packingMaterial',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.deletion',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    }
]
const receive101EntityConfigs = [
    {
        key: 'purchaseNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaseNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCode',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.itemCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectWbs',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.projectWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaseGroup',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.purchaseGroup',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.creatorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'creatorGid',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.creatorGid',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumber',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorEngName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorEngName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorChnName',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorChnName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poCrtDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.poCrtDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.requiredArrivalDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualArrivalDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.actualArrivalDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.plant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'confirmCategory',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.confirmCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorConfirmDate',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.vendorConfirmDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receivingQuantity',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.receivingQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    },
    {
        key: 'deletion',
        label: 'label.sith.inventory.sithMesInventoryItem.entity.deletion',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesInventoryItem, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, receive103FilterConfigs, receive105FilterConfigs, receive101FilterConfigs
    , receive103EntityConfigs, receive105EntityConfigs, receive101EntityConfigs
    , receive103VoConfigs, receive105VoConfigs, receive101VoConfigs
}
